// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vdmfopotjhinpmtpopny.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZkbWZvcG90amhpbnBtdHBvcG55Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjEwNjU1NTcsImV4cCI6MjA3NjY0MTU1N30.2KCvk5p14RTO1b9mGwksPe6Xm340NAs7scolpgNv99U";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});